export const BASE_URL = "http://212.113.117.140:8080";
export const BASE_URL_API = "http://212.113.117.140:5000";

export const fetchData = async (URL, options = {}, api=false) => {
  let url = api ? BASE_URL_API : BASE_URL;
  try {
    const response = await fetch(`${url}${URL}`, options);

    if (!response.ok) {
      throw response;
    }

    const data = await response?.json();
    if (data.error) {
      throw new Error(data.error);
    }

    return data.output;
  } catch (e) {
    throw e;
  }
};

export const fetchDataLocal = async (URL, options = {}) => {
  try {
    const response = await fetch(`http://localhost:5000${URL}`, options);

    if (!response.ok) {
      throw response;
    }

    const data = await response?.json();
    if (data.error) {
      throw new Error(data.error);
    }

    return data.output;
  } catch (e) {
    throw e;
  }
};